import RandingStyle17 from "../../randing/RandingStyle17";
// import { Helmet } from "react-helmet";
import RandingStyle18 from "../../randing/RandingStyle18";

function Randing100({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle18
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/100/20250218_01.png`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/100/20250218_02.gif`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/100/20250218_03.jpg`}
      // img3Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_03.jpg`}
      // img4Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_04.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_04.jpg`}
      formFieldColor="white"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/benefitArrowButton.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
      companyName="본원"
      apiUrl={apiUrl}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing100;
